import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'encodeTranslation',
    standalone: true
})
export class EncodeTranslationPipe implements PipeTransform {
  transform(value: string): string {
    return encodeURIComponent(value).replace(/%20/g, '-');
  }
}
